import { getDeviceSpec } from 'z3k-parser/model/device-spec/z3k-feature-flags';
import { selectDevice, selectSelectedDevice } from 'entities/device/lib';
import { usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { isLegacyDevice } from 'console/shared/contexts/device/config/utils';
export const isEffectiveServiceViewSelector = (state, device_id) => {
    const selectedDevice = device_id
        ? selectDevice(state, device_id)
        : selectSelectedDevice(state);
    if (!selectedDevice) {
        return false;
    }
    const manual = selectedDevice.service_mode_manual;
    const all_devices_service_mode = state.ui_settings.all_devices_service_mode ?? false;
    if (!manual && all_devices_service_mode) {
        return true;
    }
    //Если сотрудник ТП зашёл в другой аккаунт
    const is_support = state.account.real_account?.is_support;
    if (is_support) {
        return true;
    }
    const device_type = selectedDevice.device_type?.code;
    if (device_type == null) {
        return false;
    }
    const hardware_type = selectedDevice.hardware_type?.code;
    if (hardware_type == null) {
        return false;
    }
    const device_spec = getDeviceSpec(device_type, hardware_type);
    if (!device_spec.has_service_mode) {
        return false;
    }
    if (state.ui_settings.devices_service_mode?.[selectedDevice.id] !== undefined) {
        return state.ui_settings.devices_service_mode[selectedDevice.id];
    }
    if (isLegacyDevice(selectedDevice.device_type)) {
        return selectedDevice.is_legacy_service_mode_view ?? false;
    }
    return state.z3k_settings.isServiceView ?? selectedDevice.is_z3k_service_mode;
};
export const useIsServiceMode = (device_id) => {
    const is_service_mode = usePartialAppSelector(isEffectiveServiceViewSelector, device_id);
    return is_service_mode;
};
